import React, { FC } from 'react';
import { Step, StepLabel, Stepper as StepperMui } from '@mui/material';
import './CustomStepper.scss';

interface StepperProps {
  activeStep: number;
  steps: string[];
  className: string;
}

export const CustomStepper: FC<StepperProps> = ({ activeStep, steps, className }) => {
  return (
    <StepperMui activeStep={activeStep} alternativeLabel className={`custom-stepper custom-stepper__${className}`}>
      {steps.map((label) => {
        const stepProps: { completed?: boolean } = {};
        const labelProps: { optional?: React.ReactNode } = {};
        return (
          <Step key={label} {...stepProps}>
            <StepLabel {...labelProps}>{label}</StepLabel>
          </Step>
        );
      })}
    </StepperMui>
  );
};
